import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.emptystate');
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-emptystate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.emptystate/view.scss */
:host {
  display: block;
}

.lookit-empty-state {
  display: flex;
  min-height: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--lookit-border-medium);
  border-radius: var(--lookit-radius-lg);
  background: var(--lookit-color-surface-muted);
  padding: var(--lookit-space-6) var(--lookit-space-4);
  text-align: center;
}

.lookit-empty-state__icon {
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-accent-soft);
  color: var(--lookit-color-accent-strong);
}

.lookit-empty-state__icon svg {
  width: 25px;
  height: 25px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lookit-empty-state__title {
  margin-top: var(--lookit-space-3);
  color: var(--lookit-color-text);
  font-size: var(--lookit-font-size-md);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.3;
}

.lookit-empty-state__message {
  max-width: 280px;
  margin: var(--lookit-space-2) 0 0;
  color: var(--lookit-color-text-soft);
  font-size: var(--lookit-font-size-sm);
  line-height: 1.5;
}

.lookit-empty-state__action {
  min-height: var(--lookit-touch-button);
  margin-top: var(--lookit-space-4);
  border-radius: var(--lookit-radius-md);
  background: var(--lookit-color-text);
  color: var(--lookit-color-surface);
  padding: 0 var(--lookit-space-4);
  font-size: var(--lookit-font-size-sm);
  font-weight: var(--lookit-font-weight-black);
}`],
})
export class ComponentLookitEmptystateComponent {
    @Input() icon: string = 'search';
    @Input() title: string = '내용이 없습니다';
    @Input() message: string = '';
    @Input() actionLabel: string = '';
    @Output() action = new EventEmitter<void>();

    public onAction() {
        this.action.emit();
    }
}

export default ComponentLookitEmptystateComponent;